export const PLANS_INR = [
  {
    id: "starter",
    name: "Starter",
    price: 499,
    priceUSD: 6,
    period: "/mo",
    description: "For freelancers starting with a simple client workflow",
    badge: null,
    limits: {
      clients: 10,
      briefs: 10,
      invoices: 10,
      niches: 5,
      branding: false,
      team: 1,
    },
    features: [
      "Up to 10 active clients",
      "10 briefs per month",
      "10 invoices per month",
      "5 brief niches",
      "Lead and client records",
      "WhatsApp sharing",
      "Basic analytics",
      "PDF downloads",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    price: 999,
    priceUSD: 12,
    period: "/mo",
    description: "For serious freelancers and small studios",
    badge: "Most Popular",
    limits: {
      clients: Infinity,
      briefs: Infinity,
      invoices: Infinity,
      niches: 26,
      branding: true,
      team: 1,
    },
    features: [
      "Unlimited clients",
      "Unlimited briefs and invoices",
      "All 26 brief niches",
      "Custom invoice templates",
      "Branding with logo, UPI, and QR",
      "Full analytics dashboard",
      "Priority support",
      "Best for solo service providers",
    ],
  },
  {
    id: "premium",
    name: "Premium",
    price: 1699,
    priceUSD: 20,
    period: "/mo",
    description: "For power users who manage more client work",
    badge: null,
    limits: {
      clients: Infinity,
      briefs: Infinity,
      invoices: Infinity,
      niches: 26,
      branding: true,
      team: 3,
    },
    features: [
      "Everything in Pro",
      "Up to 3 team members",
      "Advanced analytics and exports",
      "Premium invoice and brief branding",
      "Team-ready client workspace",
      "Priority support",
      "1-on-1 onboarding call",
    ],
  },
  {
    id: "agency",
    name: "Agency",
    price: 3500,
    priceUSD: 35,
    period: "/mo",
    description: "For growing agencies and small teams",
    badge: "Best for Agencies",
    limits: {
      clients: Infinity,
      briefs: Infinity,
      invoices: Infinity,
      niches: 26,
      branding: true,
      team: 5,
    },
    features: [
      "Everything in Premium",
      "Up to 5 team members",
      "White-label invoices and briefs",
      "Agency-level client records",
      "Advanced reporting",
      "Dedicated onboarding support",
      "Best for multi-client teams",
    ],
  },
];

export const PLANS = PLANS_INR;

export const COMPARISON_ROWS = [
  { label: "Active clients", values: ["10", "Unlimited", "Unlimited", "Unlimited"] },
  { label: "Briefs per month", values: ["10", "Unlimited", "Unlimited", "Unlimited"] },
  { label: "Invoices per month", values: ["10", "Unlimited", "Unlimited", "Unlimited"] },
  { label: "Brief niches", values: ["5", "All 26", "All 26", "All 26"] },
  { label: "Invoice templates", values: ["1", "3", "All", "All"] },
  { label: "Custom branding", values: ["—", "Logo, UPI, QR", "Advanced", "White-label"] },
  { label: "WhatsApp and PDF sharing", values: ["✓", "✓", "✓", "✓"] },
  { label: "Analytics dashboard", values: ["Basic", "Full", "Advanced", "Advanced"] },
  { label: "Team members", values: ["1", "1", "3", "5"] },
  { label: "Lead and client records", values: ["✓", "✓", "✓", "✓"] },
  { label: "Priority support", values: ["—", "✓", "✓", "Dedicated"] },
];